import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt5" }, "すべてのスイッチを", -1)
const _hoisted_3 = { class: "fl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fl mt5" }, " / ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "rad8 pointer centered circle_button blueAround fs16 fl pad4 fw600",
          style: {"width":"52px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchAll(true)))
        }, " ON "),
        _hoisted_4,
        _createElementVNode("div", {
          class: "rad8 pointer centered circle_button blueAround fs16 fl pad4 fw600",
          style: {"width":"62px"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchAll(false)))
        }, " OFF ")
      ])
    ])
  ]))
}